import { createSlice } from '@reduxjs/toolkit'
import WordListUtils from '../../components/utils/WordListUtils'
import {setUpdate, setWlLoadedAfterUpdate, setWordListLoading} from '../utils/helpers'

import {
    createInCommunity,
    createWordList,
    deleteWordList,
    fetchCommunityWorldListsById,
    fetchWorldLists,
    updateInCommunity,
    updateWordList, updateWordListLang
} from './extraReducers'

const slice = createSlice({
    name: 'wordLists',
    initialState: {
        data: [] as any[],
        isWordListsLoading: false,
        isLoaded: false,
        selectedItem: undefined as any
    },
    reducers: {
        setWordListsRoutine: (state, action) => {
            state.data = action.payload
        },
        updateWordListRoutine: (state, action) => {
            state.data = setUpdate(state.data, action.payload);
        },
        clearWordListsRoutine: (state) => {
            state.data = []
        },
        setSelectedWordListRoutine: (state, action) => {
            state.selectedItem = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorldLists.pending, (state) => {
                state.isWordListsLoading = true
                state.isLoaded = false
            })
            .addCase(fetchWorldLists.fulfilled, (state, action) => {
                state.data = WordListUtils.mergeWordLists(state.data, WordListUtils.parseWorldLists(action.payload))
                state.isWordListsLoading = false
                state.isLoaded = true
            })
            .addCase(fetchWorldLists.rejected, (state) => {
                state.isWordListsLoading = false
                state.isLoaded = true
            })
            .addCase(fetchCommunityWorldListsById.pending, (state) => {
                state.isWordListsLoading = true
                state.isLoaded = false
            })
            .addCase(fetchCommunityWorldListsById.fulfilled, (state, action) => {
                state.data = WordListUtils.mergeWordLists(state.data, WordListUtils.parseWorldLists(action.payload))
                state.isWordListsLoading = false
                state.isLoaded = true
            })
            .addCase(fetchCommunityWorldListsById.rejected, (state) => {
                state.isWordListsLoading = false
                state.isLoaded = true
            })
            .addCase(deleteWordList.pending, (state, { meta }) => {
                const id = meta.arg
                state.data = setWordListLoading(state.data, id)
            })
            .addCase(deleteWordList.fulfilled, (state, action) => {
                state.data = [...state.data.filter((category: any) => category.id !== (action.payload as any).id)]
                state.isLoaded = true
            })
            .addCase(deleteWordList.rejected, (state) => {
                state.isLoaded = true
            })
            .addCase(updateWordList.pending, (state, { meta }) => {
                const { id } = meta.arg as any
                state.data = setWordListLoading(state.data, id)
            })
            .addCase(updateWordList.fulfilled, (state, { payload }) => {
                const { id, data } = payload as any
                state.isLoaded = true
                state.data = setWlLoadedAfterUpdate(state.data, data, id)
            })
            .addCase(updateWordList.rejected, (state) => {
                state.isWordListsLoading = false
            })
            .addCase(updateWordListLang.fulfilled, (state, { payload }) => {
                const { id, data } = payload as any
                state.isLoaded = true
                state.data = setWlLoadedAfterUpdate(state.data, data, id)
            })
            .addCase(createWordList.pending, (state, { meta }) => {
                const { id } = meta.arg as any
                state.data = setWordListLoading(state.data, id)
            })
            .addCase(createWordList.fulfilled, (state, action) => {
                const { savedWordList } = action.payload as any
                state.isLoaded = true
                state.data = [...state.data, WordListUtils.parseNewWordList(savedWordList)]
            })
            .addCase(createWordList.rejected, (state) => {
                state.isWordListsLoading = false
            })
            .addCase(updateInCommunity.pending, (state, { meta }) => {
                const { id } = meta.arg as any
                state.data = setWordListLoading(state.data, id)
            })
            .addCase(updateInCommunity.fulfilled, (state, { payload }) => {
                const { id, data } = payload as any
                state.isLoaded = true
                state.data = setWlLoadedAfterUpdate(state.data, data, id)
            })
            .addCase(updateInCommunity.rejected, (state) => {
                state.isWordListsLoading = false
            })
            .addCase(createInCommunity.pending, (state, { meta }) => {
                const { id } = meta.arg as any
                state.data = setWordListLoading(state.data, id)
            })
            .addCase(createInCommunity.fulfilled, (state, action) => {
                const { wordList } = action.payload as any
                state.isLoaded = true
                state.data = [...state.data, WordListUtils.parseNewWordList(wordList)]
                state.selectedItem = wordList.id
            })
            .addCase(createInCommunity.rejected, (state) => {
                state.isWordListsLoading = false
            })
    }
})

export const { setWordListsRoutine, clearWordListsRoutine, setSelectedWordListRoutine, updateWordListRoutine } = slice.actions
export const wordListsDataSelector = (state: any) => state.wordLists.data
export const selectedWordListIdSelector = (state: any) => state.wordLists.selectedItem
export const wordsListsLoadingStatusSelector = (state: any) => state.wordLists.isWordListsLoading
export const wordsListsIsLoadedStatusSelector = (state: any) => state.wordLists.isLoaded
export const wordListByIdSelector = (id: number) => (state: any) => state.wordLists.data.find((wl: any) => wl.id === id)
export default slice.reducer
